export const CHECK_AUTH = "checkAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const FETCH_CURRENT_USER = "fetchCurrentUser";

export const SHOW_SNACKBAR = "showSnackbar";
export const CLICK_CREATE_BUTTON = "clickCreateButton";
export const CLICK_REFRESH_BUTTON = "clickRefreshButton";
export const VALIDATION = "validationErrors";
export const RESET_VALIDATION = "resetValidationErrors";
export const CHANGE_AUTO_REFRESH_TIME = "changeAutoRefreshTime";
export const FETCH_DICTIONARY = "fetchDictionary";

export const FETCH_USERS = "fetchUsers";
export const FETCH_USER = "fetchUser";
export const UPDATE_USER = "updateUser";
export const CREATE_USER = "createUser";
export const RESET_USER = "resetUser";
export const DELETE_USER = "deleteUser";

export const FETCH_VEHICLES = "fetchVehicles";
export const FETCH_VEHICLE = "fetchVehicle";
export const UPDATE_VEHICLE = "updateVehicle";
export const CREATE_VEHICLE = "createVehicle";
export const RESET_VEHICLE = "resetVehicle";
export const DELETE_VEHICLE = "deleteVehicle";

export const FETCH_FAULT_MESSAGES = "fetchFaultMessages";
export const FETCH_FAULT_MESSAGE = "fetchFaultMessage";
export const UPDATE_FAULT_MESSAGE = "updateFaultMessage";
export const CREATE_FAULT_MESSAGE = "createFaultMessage";
export const RESET_FAULT_MESSAGE = "resetFaultMessage";
export const DELETE_FAULT_MESSAGE = "deleteFaultMessage";

export const FETCH_FLEETS = "fetchFleets";
export const FETCH_FLEET = "fetchFleet";
export const UPDATE_FLEET = "updateFleet";
export const CREATE_FLEET = "createFleet";
export const RESET_FLEET = "resetFleet";
export const DELETE_FLEET = "deleteFleet";

export const FETCH_ISSUES = "fetchIssues";
export const FETCH_ISSUE = "fetchIssue";
export const UPDATE_ISSUE = "updateIssue";
export const CREATE_ISSUE = "createIssue";
export const RESET_ISSUE = "resetIssue";
export const DELETE_ISSUE = "deleteIssue";
export const UPDATE_ISSUE_STATUS = "updateIssueStatus";
export const FETCH_ISSUE_STATUS_HISTORY = "fetchIssueStatusHistory";
export const FINNISH_ISSUE = "finnishIssue";

export const FETCH_COMPONENTS = "fetchComponents";
export const FETCH_COMPONENT = "fetchComponent";
export const UPDATE_COMPONENT = "updateComponent";
export const CREATE_COMPONENT = "createComponent";
export const RESET_COMPONENT = "resetComponent";
export const DELETE_COMPONENT = "deleteComponent";

export const FETCH_SERVICE_REPORTS = "fetchServiceReports";
export const FETCH_SERVICE_REPORT = "fetchServiceReport";
export const UPDATE_SERVICE_REPORT = "updateServiceReport";
export const CREATE_SERVICE_REPORT = "createServiceReport";
export const RESET_SERVICE_REPORT = "resetServiceReport";
export const DELETE_SERVICE_REPORT = "deleteServiceReport";
export const FETCH_SERVICE_REPORTS_FOR_ISSUE = "fetchServiceReportsForIssue";

export const FETCH_REVIEW_REPORTS = "fetchReviewReports";
export const FETCH_REVIEW_REPORT = "fetchReviewReport";
export const UPDATE_REVIEW_REPORT = "updateReviewReport";
export const CREATE_REVIEW_REPORT = "createReviewReport";
export const RESET_REVIEW_REPORT = "resetReviewReport";
export const DELETE_REVIEW_REPORT = "deleteReviewReport";

export const FETCH_BASIC_REPORT = "fetchBasicReport";
export const FETCH_DETAILED_REPORT = "fetchDetailedReport";
export const FETCH_ISSUES_REPORT = "fetchIssuesReport";
export const RESET_REPORT = "resetReport";

export const FETCH_DASHBOARD_STATISTICS = "fetchDashboardStatistics";
export const FETCH_CHART_VEHICLES_DISTANCE =
  "fetchDashboardChartVehiclesDistance";
export const FETCH_CHART_ISSUES_STATUS = "fetchDashboardChartIssuesStatus";

export const FETCH_COEFFICIENT_READINESS_YEARLY =
  "fetchCoefficientReadinessYearly";
export const UPDATE_COEFFICIENT_READINESS = "updateCoefficientReadiness";

export const FETCH_COEFFICIENT_RELIABILITY_QUARTERLY =
  "fetchCoefficientReliabilityQuarterly";
export const FETCH_COEFFICIENT_RELIABILITY = "fetchCoefficientReliability";
export const UPDATE_COEFFICIENT_RELIABILITY = "updateCoefficientReliability";

export const FETCH_SPARE_PART_TYPES = "fetchSparePartTypes";
export const FETCH_SPARE_PART_TYPE = "fetchSparePartType";
export const UPDATE_SPARE_PART_TYPE = "updateSparePartType";
export const CREATE_SPARE_PART_TYPE = "createSparePartType";
export const RESET_SPARE_PART_TYPE = "resetSparePartType";
export const DELETE_SPARE_PART_TYPE = "deleteSparePartType";

export const FETCH_SPARE_PARTS = "fetchSpareParts";
export const FETCH_SPARE_PART = "fetchSparePart";
export const UPDATE_SPARE_PART = "updateSparePart";
export const CREATE_SPARE_PART = "createSparePart";
export const RESET_SPARE_PART = "resetSparePart";
export const DELETE_SPARE_PART = "deleteSparePart";

export const FETCH_VEHICLE_SPARE_PARTS = "fetchVehicleSpareParts";
export const FETCH_VEHICLE_SPARE_PART_HISTORY = "fetchVehicleSparePartHistory";
